import { ALL_TRAFFIC } from '@utils/filter';
import calcShortcutInterval from '@utils/calcShortcutInterval';
import { DATE_SHORTCUTS } from '@utils/constants';
import getGranularity from '@utils/granularity';
import { FLOW_PRESET_DEFAULT_DIMENSIONS } from '@src/utils/dimension/appDimensionHelper';

const calIntervalObjFromShortcut = (shortcut) => {
  const [from, to] = calcShortcutInterval(shortcut);
  return {
    shortcut,
    from,
    to,
    granularity: getGranularity({ from, to, minuteGranularity: true, overview: false, shortcut }),
  };
};

const excludeMetrics = ['sessions_without_signal', 'users_without_signal'];

export const createEventPreset = ({ metrics, validateDimension, eventConfigMeta }) => {
  const metaDefinition: Array<{ identifier: string; type: string; output_order: number | null }> =
    Array.isArray(eventConfigMeta.metaDefinition)
      ? eventConfigMeta.metaDefinition
      : eventConfigMeta.metaDefinition?.metrics ?? [];

  const eventMetrics = metaDefinition
    .filter(
      (it) =>
        !!it.type && metrics[it.identifier]?.active && !excludeMetrics.includes(it.identifier),
    )
    .sort((a, b) => (a.output_order ?? Infinity) - (b.output_order ?? Infinity))
    .map((it) => it.identifier);

  if (!eventMetrics.length) return {};
  const presetConfig = {
    title: eventConfigMeta.display_name || eventConfigMeta.name,
    key: eventConfigMeta.entity_type_id || eventConfigMeta.identifier,
    config: {
      metricsChartContainer: {
        metric: eventMetrics[0],
        metrics: [...eventMetrics],
      },
      common: {
        appliedFilters: [ALL_TRAFFIC],
        interval: calIntervalObjFromShortcut(DATE_SHORTCUTS.last6Hours),
      },
      'module:trends': {
        base: {
          dimensions: validateDimension(FLOW_PRESET_DEFAULT_DIMENSIONS),
          dimensionMetrics: eventMetrics,
        },
      },
    },
  };
  return presetConfig;
};
